module.exports = __webpack_public_path__ + "img/briefs-show.96aebaa1.png";